import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { defaultColors } from "../../datas/colors";

export default function PieChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: [
          "Mostrar, Apresentar, Caracterizar, Representar",
          "Evidenciar, Refletir, Fundamentar, Contribuir",
          "Comparar, Associar, Relacionar, Vincular",
          "Possibilitar, Utilizar, Concluir",
        ],
        datasets: [
          {
            label: "",
            data: [141, 91, 105, 77],
            backgroundColor: defaultColors,
            borderWidth: 0,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "55%",
        animation: {
          animateRotate: true,
          animateScale: true,
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              font: {
                size: 14,
                weight: "bold",
              },
            },
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff", // Fundo branco
            titleColor: "#333333", // Cor do título mais escura para melhor leitura
            titleFont: { weight: "bold", size: 14 }, // Fonte do título mais destacada
            bodyColor: "#444444", // Cor do corpo (habilidade + descrição)
            bodyFont: { size: 13 }, // Tamanho da fonte do corpo
            footerColor: "#1565C0", // Azul mais sofisticado para o footer
            footerFont: { weight: "bold", size: 12 }, // Fonte do footer destacada
            borderColor: "#DDDDDD", // Borda cinza clara
            borderWidth: 1,
            cornerRadius: 10, // Cantos mais arredondados
            padding: 12, // Mais espaço para melhor visualização
            displayColors: false,
          },
        },
      },
    });

    return () => chartInstance.current.destroy();
  }, []);

  return (
    <div className="p-6 w-full bg-white shadow-lg rounded-xl border md:w-1/2 border-gray-200">
      <h2 className="text-2xl font-bold text-center">
        Verbos mais comuns em questões
      </h2>
      <div className="relative w-full h-80 mt-6">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
}
